export default function FileReceiver(props) {
  const { handleRequestFile, videoSrc, buttonsData } = props;

  if (!videoSrc && !buttonsData?.length) {
    return null;
  }

  return (
    <>
      {videoSrc ? (
        <article className="tg-scene-video">
          <video controls playsInline preload="metadata">
            <source src={videoSrc} type="video/mp4" />
            Ваш браузер не поддерживает воспроизведение видео.
          </video>
        </article>
      ) : null}

      {buttonsData?.length ? (
        <div className="tg-scene-buttons">
          {buttonsData.map((el, index) => (
            <button
              type="button"
              key={el.id ?? index}
              className="tg-scene-button"
              onClick={() => handleRequestFile(el.id)}
            >
              {el.data?.label}
            </button>
          ))}
        </div>
      ) : null}
    </>
  );
}
